/*
 * @Author: ken yang
 * @Date: 2022-09-09 14:01:00
 * @LastEditTime: 2022-10-19 10:59:29
 * @LastEditors: zheng zheng@sence.sg
 * @Description:
 * @FilePath: \nicee-h5\src\router-hgb.js
 */

const routers = [
  // 水晶活動
  {
    path: '/crystal-draw',
    name: 'crystalDraw',
    component: () => import('./views/activity/crystal-draw/crystal-draw.vue')
  },
  //國慶紅包活動
  {
    path: '/national-Day-activities',
    name: 'nationalDayActivities',
    component: () =>
      import('./views/activity/national-Day-activities/index.vue')
  },
  //週星排行活動
  {
    path: '/ranking-list',
    name: 'rankingList',
    component: () => import('./activities/star-week/ranking-list.vue')
  },
  //週星名人堂排行
  {
    path: '/hall-fame',
    name: 'hallFame',
    component: () => import('./activities/star-week/hall-fame.vue')
  },
  //幸運糖果奪寶
  {
    path: '/candies-draw',
    name: 'candiesDraw',
    component: () => import('./views/activity/candies-draw/candies-draw.vue')
  },
  //萬聖節活動
  {
    path: '/halloween-draw',
    name: 'halloweenDraw',
    component: () => import('./activities/halloween-draw/index.vue')
  },
  //周星預熱活動
  {
    path: '/starweek-preheat',
    name: 'starweekPreheat',
    component: () => import('./activities/starweek-preheat/index.vue')
  },
  //雙十一儲值活動
  {
    path: '/double-eleven-second',
    name: 'doubleElevenSecond',
    component: () => import('./activities/double-eleven-second/index.vue')
  },
  //水晶活動第四期
  {
    path: '/crystal-fourth',
    name: 'crystalFourth',
    component: () => import('./activities/crystal-fourth/index.vue')
  }
];
export default routers;
